import React, { useEffect } from 'react'
import { View, TouchableOpacity, StatusBar, Platform, Dimensions } from 'react-native'
import PropTypes from 'prop-types'
import LinearGradient from 'react-native-linear-gradient'
import { SafeAreaView } from 'react-native-safe-area-context'

import { VFText, VFButton, Icon } from '@vfgroup-oneplatform/foundation/Components'
import { Colors, Images, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { Images as images } from '../../Themes'

import styles from './Start.Styles'


const Start = ({
  onStartJourney,
  theme,
  onClose,
}) => {

  const simCards = [
    { icon: 'miniSim', title: 'Mini SIM' },
    { icon: 'microSim', title: 'Micro SIM' },
    { icon: 'nanoSim', title: 'Nano SIM' },
  ]


  const getNewNumber = () => {
    onStartJourney()
  }

  const close = () => {
    onClose()
  }

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View style={styles.container}>
        <LinearGradient
          colors={[Colors.darkRedTwo, Colors.vfRed]}
          useAngle={true}
          angleCenter={{ x: 0.5, y: 0.5 }}
          angle={30}
          style={styles.startContainer}
        >
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>


            <VFText
              i18nKey="acquisition_intro_screen_title"
              style={styles.title}
            />

            <TouchableOpacity style={{ alignSelf: 'flex-end' }} onPress={close} >
              <Icon
                name={Images.ic_close_white}
                type="image"
                size={25}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
          <View style={styles.cardsContainer}>
            {simCards.map(simCard => {
              return (
                <View style={styles.cardContainer}>
                  <Icon
                    name={images[simCard.icon]}
                    type="image"
                    size={100}
                    resizeMode="contain"
                  />
                  <VFText
                    i18nKey={simCard.title}
                    style={styles.simName}
                  />
                </View>
              )
            })}
          </View>
        </LinearGradient >
        <SafeAreaView style={styles.bottomContainer(theme)}>
          <View style={styles.textContainer}>
            <VFText
              i18nKey="acquisition_intro_screen_subtitle"
              style={styles.text}
            />
          </View>

          <VFButton
            title="acquisition_join_button"
            style={[styles.button, { width: '80%' }]}
            onPress={getNewNumber}
          />
        </SafeAreaView>
      </View>
    )
  }


  return (
    <View style={styles.container}>
      <LinearGradient
        colors={[Colors.darkRedTwo, Colors.vfRed]}
        useAngle={true}
        angleCenter={{ x: 0.5, y: 0.5 }}
        angle={30}
        style={styles.startContainer}
      >
        <TouchableOpacity style={styles.closeIcon} onPress={close} >
          <Icon
            name={Images.ic_close_white}
            type="image"
            size={25}
            resizeMode="contain"
          />
        </TouchableOpacity>

        <VFText
          i18nKey="acquisition_intro_screen_title"
          style={styles.title}
        />

        <View style={styles.cardsContainer}>
          {simCards.map(simCard => {
            return (
              <View style={styles.cardContainer}>
                <Icon
                  name={images[simCard.icon]}
                  type="image"
                  size={100}
                  resizeMode="contain"
                />
                <VFText
                  i18nKey={simCard.title}
                  style={styles.simName}
                />
              </View>
            )
          })}
        </View>
      </LinearGradient >
      <SafeAreaView style={styles.bottomContainer(theme)}>
        <View style={styles.textContainer}>
          <VFText
            i18nKey="acquisition_intro_screen_subtitle"
            style={styles.text}
          />
        </View>

        <VFButton
          title="acquisition_join_button"
          style={styles.button}
          onPress={getNewNumber}
        />
      </SafeAreaView>
    </View>
  )
}
Start.defaultProps = {
  theme: {
    name: 'light',
    colors: LightThemeColors,
  },
}

Start.propTypes = {
  onStartJourney: PropTypes.func,
  theme: PropTypes.object,
  onClose: PropTypes.object,
}

export default Start
